/** @format **/

import React from 'react';
import { createComponent } from 'react-fela';
import { IStyle } from 'fela';

const StyledTabPane = (): IStyle => ({});

export const TabPane = createComponent(StyledTabPane);
